// extracted by mini-css-extract-plugin
export default {"centered":"PasswordRecovery_centered__wkcWo","centeredText":"PasswordRecovery_centeredText__x-iwQ"};